(function () {
  'use strict';

  var DEBOUNCE = 250;
  var LOADING_MIN = 200;

  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return [].slice.call(document.querySelectorAll(s)); };

  var searchInput = $('#gf-search');
  var catCheckboxes = $$('.gf-coll__cat');
  var brandCheckboxes = $$('.gf-coll__brand');
  var sizeCheckboxes = $$('.gf-coll__size');
  var colorCheckboxes = $$('.gf-coll__color');
  var themeCheckboxes = $$('.gf-coll__theme');
  var typeCheckboxes = $$('.gf-coll__type');
  var priceMin = $('#gf-price-min');
  var priceMax = $('#gf-price-max');
  var priceWarn = $('#gf-price-warn');
  var availableOnly = $('#gf-available');
  var sortSelect = $('#gf-sort');
  var resetButton = $('#gf-reset');
  var emptyResetBtn = $('#gf-empty-reset');
  var gridCollection = $('#gf-grid-collection');
  var emptyState = $('#gf-empty');
  var counter = $('#gf-count');

  var inputTimer = null;

  /* Auf /collections/vendors und /collections/types ist ?q= Shopifys Marken- bzw. Typfilter.
     Dort nutzt die Freitextsuche einen eigenen Parameter und laesst q unangetastet. */
  var SHOPIFY_Q = /^\/collections\/(vendors|types)\/?$/.test(window.location.pathname);
  var SK = SHOPIFY_Q ? 's' : 'q';
  var loadingTimer = null;

  function showLoading() {
    if (gridCollection) gridCollection.classList.add('is-loading');
  }
  function hideLoading() {
    if (gridCollection) gridCollection.classList.remove('is-loading');
  }

  function readURLState() {
    var p = new URLSearchParams(window.location.search);
    return {
      q: p.get(SK) || '',
      cats: p.getAll('cat'),
      brands: p.getAll('brand'),
      themes: p.getAll('theme'),
      types: p.getAll('type'),
      sizes: p.getAll('size'),
      colors: p.getAll('color'),
      min: p.get('min') || '',
      max: p.get('max') || '',
      available: p.get('available') !== '0',
      sort: p.get('sort_by') || 'manual'
    };
  }

  function writeURLState(state) {
    var url = new URL(window.location.href);
    [SK, 'cat', 'brand', 'theme', 'type', 'size', 'color', 'min', 'max', 'available'].forEach(function (k) {
      url.searchParams.delete(k);
    });
    if (state.q) url.searchParams.set(SK, state.q);
    state.cats.forEach(function (c) { url.searchParams.append('cat', c); });
    state.brands.forEach(function (b) { url.searchParams.append('brand', b); });
    state.themes.forEach(function (th) { url.searchParams.append('theme', th); });
    state.types.forEach(function (tp) { url.searchParams.append('type', tp); });
    state.sizes.forEach(function (sz) { url.searchParams.append('size', sz); });
    state.colors.forEach(function (co) { url.searchParams.append('color', co); });
    if (state.min) url.searchParams.set('min', state.min);
    if (state.max) url.searchParams.set('max', state.max);
    if (!state.available) url.searchParams.set('available', '0');
    window.history.replaceState(null, '', url);
  }

  function applyURLToUI(state) {
    searchInput.value = state.q;
    priceMin.value = state.min;
    priceMax.value = state.max;
    availableOnly.checked = state.available;
    sortSelect.value = state.sort;
    $$('.gf-coll__cat').forEach(function (cb) {
      cb.checked = state.cats.indexOf(cb.value) !== -1;
    });
    $$('.gf-coll__brand').forEach(function (cb) {
      cb.checked = state.brands.indexOf(cb.value) !== -1;
    });
    $$('.gf-coll__size').forEach(function (cb) {
      cb.checked = state.sizes.indexOf(cb.value) !== -1;
    });
    $$('.gf-coll__color').forEach(function (cb) {
      cb.checked = state.colors.indexOf(cb.value) !== -1;
    });
    $$('.gf-coll__theme').forEach(function (cb) {
      cb.checked = state.themes.indexOf(cb.value) !== -1;
    });
    $$('.gf-coll__type').forEach(function (cb) {
      cb.checked = state.types.indexOf(cb.value) !== -1;
    });
  }

  function getUIState() {
    return {
      q: searchInput.value.trim(),
      cats: $$('.gf-coll__cat').filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; }),
      brands: $$('.gf-coll__brand').filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; }),
      themes: $$('.gf-coll__theme').filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; }),
      types: $$('.gf-coll__type').filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; }),
      sizes: $$('.gf-coll__size').filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; }),
      colors: $$('.gf-coll__color').filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; }),
      min: priceMin.value.trim(),
      max: priceMax.value.trim(),
      available: availableOnly.checked,
      sort: sortSelect.value
    };
  }

  function enhancePaginationLinks() {
    var current = new URL(window.location.href);
    $$('[data-page-link]').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      [SK, 'cat', 'brand', 'theme', 'type', 'size', 'color', 'min', 'max', 'available'].forEach(function (k) {
        url.searchParams.delete(k);
      });
      [SK, 'cat', 'brand', 'theme', 'type', 'size', 'color', 'min', 'max', 'available'].forEach(function (k) {
        current.searchParams.getAll(k).forEach(function (v) {
          url.searchParams.append(k, v);
        });
      });
      link.href = url.toString();
    });
  }

  function validatePriceInputs() {
    var minRaw = priceMin.value.trim();
    var maxRaw = priceMax.value.trim();
    if (minRaw === '' || maxRaw === '') { if (priceWarn) priceWarn.hidden = true; return; }
    var minN = parseFloat(minRaw);
    var maxN = parseFloat(maxRaw);
    if (!isNaN(minN) && !isNaN(maxN) && minN > maxN) {
      priceMin.value = String(maxN);
      priceMax.value = String(minN);
      if (priceWarn) {
        priceWarn.hidden = false;
        clearTimeout(priceWarn._t);
        priceWarn._t = setTimeout(function () { priceWarn.hidden = true; }, 2400);
      }
    }
  }

  function applyFiltersCollection() {
    var state = getUIState();
    var cards = $$('#gf-grid-collection .gf-card');
    var minP = state.min ? parseFloat(state.min) : 0;
    var maxP = state.max ? parseFloat(state.max) : Infinity;
    var query = (state.q || '').toLowerCase();
    var visible = 0;

    cards.forEach(function (card) {
      var price = parseFloat(card.dataset.price) || 0;
      var avail = card.dataset.available === 'true';
      var cats = card.dataset.categories ? card.dataset.categories.split(',') : [];
      var title = card.dataset.title || '';
      var vendor = card.dataset.vendor || '';
      var csizes = card.dataset.sizes ? card.dataset.sizes.split(',').filter(Boolean) : [];
      var ccolor = card.dataset.color || '';
      var ctheme = card.dataset.theme || '';
      var ctypes = (card.dataset.type || '').split(',').filter(Boolean);

      var mCat = state.cats.length === 0 || state.cats.some(function (c) { return cats.indexOf(c) !== -1; });
      var mPrice = price >= minP && price <= maxP;
      var mAvail = !state.available || avail;
      var mQuery = query.length === 0 || title.indexOf(query) !== -1 || vendor.indexOf(query) !== -1;
      var mBrand = state.brands.length === 0 || state.brands.indexOf(vendor) !== -1;
      var mSize = state.sizes.length === 0 || state.sizes.some(function (sz) { return csizes.indexOf(sz) !== -1; });
      var mColor = state.colors.length === 0 || state.colors.indexOf(ccolor) !== -1;
      var mTheme = state.themes.length === 0 || state.themes.indexOf(ctheme) !== -1;
      var mType = state.types.length === 0 || state.types.some(function (tp) { return ctypes.indexOf(tp) !== -1; });

      var show = mCat && mPrice && mAvail && mQuery && mBrand && mSize && mColor && mTheme && mType;
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    /* CSS blendet ausverkaufte Karten schon vor dem Skript aus (kein Springen beim Laden).
       Ist "Nur verfügbare" abgewählt, hebt diese Klasse die CSS-Regel auf. */
    if (gridCollection) gridCollection.classList.toggle('gf-show-soldout', !state.available);

    /* Ohne eigene Filter zeigt die Leiste die Zahl der ganzen Kategorie vom Server
       (lieferbare bzw. alle Artikel), nicht nur die der bisher geladenen Seiten. */
    var narrowed = !!(state.q || state.cats.length || state.brands.length || state.themes.length ||
      state.types.length || state.sizes.length || state.colors.length || state.min || state.max);
    var total = state.available ? counter.dataset.totalAvailable : counter.dataset.total;
    var shown = (!narrowed && total) ? parseInt(total, 10) : visible;
    counter.textContent = shown + ' Artikel';
    var moreComing = !!(window.gfHasMorePages && window.gfHasMorePages());
    emptyState.hidden = visible > 0 || moreComing;
    hideLoading();

    /* Zu wenig auf dem Schirm oder Filter aktiv: weitere Seiten automatisch nachladen,
       damit Filter die ganze Kategorie durchsuchen und Seite 1 nicht halb leer ist. */
    if (window.gfAutoLoad) window.gfAutoLoad(visible, narrowed || !state.available);
  }

  function refresh(opts) {
    opts = opts || {};
    writeURLState(getUIState());
    if (opts.withLoading) {
      clearTimeout(loadingTimer);
      loadingTimer = setTimeout(showLoading, LOADING_MIN);
    }
    applyFiltersCollection();
    clearTimeout(loadingTimer);
    hideLoading();
    enhancePaginationLinks();
  }

  function debouncedRefresh() {
    clearTimeout(inputTimer);
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(showLoading, LOADING_MIN);
    inputTimer = setTimeout(function () { refresh(); }, DEBOUNCE);
  }

  searchInput.addEventListener('input', debouncedRefresh);

  catCheckboxes.forEach(function (cb) {
    cb.addEventListener('change', function () { refresh(); });
  });
  brandCheckboxes.forEach(function (cb) {
    cb.addEventListener('change', function () { refresh(); });
  });
  sizeCheckboxes.forEach(function (cb) {
    cb.addEventListener('change', function () { refresh(); });
  });
  colorCheckboxes.forEach(function (cb) {
    cb.addEventListener('change', function () { refresh(); });
  });
  themeCheckboxes.forEach(function (cb) {
    cb.addEventListener('change', function () { refresh(); });
  });
  typeCheckboxes.forEach(function (cb) {
    cb.addEventListener('change', function () { refresh(); });
  });

  [priceMin, priceMax].forEach(function (input) {
    input.addEventListener('input', debouncedRefresh);
    input.addEventListener('blur', function () { validatePriceInputs(); refresh(); });
  });

  availableOnly.addEventListener('change', function () { refresh(); });

  sortSelect.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });

  function doReset() {
    var url = new URL(window.location.href);
    [SK, 'cat', 'brand', 'theme', 'type', 'size', 'color', 'min', 'max', 'available', 'sort_by', 'page'].forEach(function (k) {
      url.searchParams.delete(k);
    });
    window.location.href = url.toString();
  }

  resetButton.addEventListener('click', doReset);
  if (emptyResetBtn) emptyResetBtn.addEventListener('click', doReset);

  function init() {
    var state = readURLState();
    applyURLToUI(state);
    applyFiltersCollection();
    enhancePaginationLinks();
  }

  window.gfRefreshFilters = function () { refresh(); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --- Load-More + dynamische Filter-Expansion --- */
(function () {
  var btn = document.getElementById('gf-load-more');
  if (!btn) return;
  var grid = document.getElementById('gf-grid-collection');
  if (!grid) return;

  function cssEscape(v) {
    if (window.CSS && CSS.escape) return CSS.escape(v);
    return String(v).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function ensureCheckbox(group, value, labelText) {
    if (!value) return;
    var cls = 'gf-coll__' + group;
    if (document.querySelector('input.' + cls + '[value="' + cssEscape(value) + '"]')) return;
    var labels = { brand: 'Marke', size: 'Gr\u00f6\u00dfe', color: 'Farbe', theme: 'Thema', type: 'Typ' };
    var sectionLabel = labels[group];
    var sections = document.querySelectorAll('.gf-coll__sidebar .gf-coll__filter');
    var target = null;
    sections.forEach(function (sec) {
      var lab = sec.querySelector('.gf-coll__label');
      if (lab && lab.textContent.trim() === sectionLabel) target = sec;
    });
    if (!target) return;
    var area = target.querySelector(group === 'size' ? '.gf-coll__sizes' : '.gf-coll__checkboxes');
    if (!area) return;
    var labelEl = document.createElement('label');
    labelEl.className = group === 'size' ? 'gf-coll__size-chip' : 'gf-coll__check';
    var input = document.createElement('input');
    input.type = 'checkbox';
    input.className = cls;
    input.value = value;
    var span = document.createElement('span');
    span.textContent = group === 'size' ? String(labelText).toUpperCase() : labelText;
    labelEl.appendChild(input);
    labelEl.appendChild(span);
    input.addEventListener('change', function () {
      if (window.gfRefreshFilters) window.gfRefreshFilters();
    });
    area.appendChild(labelEl);
  }

  function cap(s) { return s ? (s.charAt(0).toUpperCase() + s.slice(1)).replace(/^Pokemon/, 'Pokémon') : s; }

  function indexNewCards(cards) {
    cards.forEach(function (card) {
      var v = card.dataset.vendor;
      if (v) ensureCheckbox('brand', v, cap(v));
      (card.dataset.sizes || '').split(',').filter(Boolean).forEach(function (sz) {
        ensureCheckbox('size', sz, sz);
      });
      var c = card.dataset.color;
      if (c) ensureCheckbox('color', c, cap(c));
      var th = card.dataset.theme;
      if (th) ensureCheckbox('theme', th, cap(th));
      (card.dataset.type || '').split(',').filter(Boolean).forEach(function (tp) {
        ensureCheckbox('type', tp, cap(tp));
      });
    });
  }

  var isLoading = false;
  function loadNext() {
    if (isLoading) return;
    var nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;
    isLoading = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    var textSpan = btn.querySelector('.gf-coll__load-text');
    var origText = textSpan ? textSpan.textContent : 'Mehr laden';
    if (textSpan) textSpan.textContent = 'L\u00e4dt \u2026';
    fetch(nextUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newCards = Array.prototype.slice.call(doc.querySelectorAll('#gf-grid-collection .gf-card'));
        newCards.forEach(function (c) { grid.appendChild(c); });
        indexNewCards(newCards);
        var newBtn = doc.getElementById('gf-load-more');
        if (newBtn && newBtn.dataset.nextUrl) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          var info = newBtn.querySelector('.gf-coll__load-info');
          var ourInfo = btn.querySelector('.gf-coll__load-info');
          if (info && ourInfo) ourInfo.textContent = info.textContent;
          btn.disabled = false;
          btn.classList.remove('is-loading');
          if (textSpan) textSpan.textContent = origText;
        } else {
          btn.style.display = 'none';
        }
        isLoading = false;
        if (window.gfRefreshFilters) window.gfRefreshFilters();
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (textSpan) textSpan.textContent = origText;
        isLoading = false;
      });
  }

  btn.addEventListener('click', loadNext);

  var MIN_FILL = 24;
  window.gfHasMorePages = function () {
    return !!btn.dataset.nextUrl && btn.style.display !== 'none';
  };
  window.gfAutoLoad = function (visible, all) {
    if (isLoading || !window.gfHasMorePages()) return;
    if (all || visible < MIN_FILL) loadNext();
  };

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !btn.disabled && btn.dataset.nextUrl && btn.style.display !== 'none') {
          loadNext();
        }
      });
    }, { rootMargin: '400px' });
    obs.observe(btn);
  }

  /* Erste Pruefung: das Filter-Skript oben lief schon, bevor gfAutoLoad existierte */
  if (window.gfRefreshFilters) window.gfRefreshFilters();
})();

  // gf quick-add ============================================================
  function gfRefreshCartLimits() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var map = {};
        (c.items || []).forEach(function(it){ map[it.variant_id] = (map[it.variant_id]||0) + it.quantity; });
        document.querySelectorAll('.gf-qa__add').forEach(function(btn){
          var vid = parseInt(btn.getAttribute('data-vid'), 10);
          var mgmt = btn.getAttribute('data-mgmt');
          var pol = btn.getAttribute('data-pol');
          var stock = parseInt(btn.getAttribute('data-stock'), 10);
          var qa = btn.closest('[data-qa]');
          if (!qa) return;
          var stepPlus = qa.querySelector('.gf-qa__step[data-step="1"]');
          var num = qa.querySelector('.gf-qa__num');
          if (mgmt !== 'shopify' || pol !== 'deny' || isNaN(stock)) return;
          var inCart = map[vid] || 0;
          var rem = Math.max(0, stock - inCart);
          btn.setAttribute('data-max', rem);
          var n = parseInt(num.textContent, 10) || 1;
          if (rem <= 0) {
            btn.classList.add('is-maxed');
            btn.disabled = true;
            btn.setAttribute('aria-label', 'Bereits im Warenkorb');
            btn.setAttribute('title', 'Du hast bereits alle verfügbaren Stück im Warenkorb');
            if (stepPlus) stepPlus.disabled = true;
            num.textContent = '0';
          } else {
            btn.classList.remove('is-maxed');
            btn.disabled = false;
            btn.setAttribute('aria-label', 'In den Warenkorb');
            btn.setAttribute('title', 'In den Warenkorb');
            if (stepPlus) stepPlus.disabled = false;
            if (n > rem) num.textContent = rem;
            if (n < 1) num.textContent = 1;
          }
        });
        var bubble = document.getElementById('gf-cart-bubble');
        if (bubble) {
          bubble.textContent = c.item_count;
          bubble.setAttribute('data-count', c.item_count);
          if (c.item_count > 0) bubble.removeAttribute('hidden'); else bubble.setAttribute('hidden','');
        }
        return c;
      }).catch(function(){});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gfRefreshCartLimits);
  } else { gfRefreshCartLimits(); }

  document.addEventListener('click', function(e){
    var step = e.target.closest('.gf-qa__step');
    var add  = e.target.closest('.gf-qa__add');
    if (!step && !add) return;
    e.preventDefault(); e.stopPropagation();
    if (step) {
      if (step.disabled) return;
      var qa = step.closest('[data-qa]');
      var num = qa.querySelector('.gf-qa__num');
      var addBtn = qa.querySelector('.gf-qa__add');
      var max  = parseInt(addBtn.getAttribute('data-max'), 10);
      var n = parseInt(num.textContent, 10) || 1;
      n += parseInt(step.getAttribute('data-step'), 10);
      if (n < 1) n = 1;
      if (!isNaN(max) && n > max) n = max;
      num.textContent = n;
      return;
    }
    if (add.disabled || add.classList.contains('is-maxed')) return;
    var qa2 = add.closest('[data-qa]');
    var qty = parseInt(qa2.querySelector('.gf-qa__num').textContent, 10) || 1;
    var vid = add.getAttribute('data-vid');
    add.disabled = true;
    add.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: vid, quantity: qty })
    })
    .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, data: d }; }); })
    .then(function(res){
      if (!res.ok) {
        add.classList.remove('is-loading');
        add.classList.add('is-error');
        setTimeout(function(){ add.disabled = false; add.classList.remove('is-error'); gfRefreshCartLimits(); }, 1600);
        return;
      }
      add.classList.remove('is-loading');
      add.classList.add('is-success');
      gfRefreshCartLimits().then(function(){
        var bubble = document.getElementById('gf-cart-bubble');
        if (bubble) {
          bubble.classList.remove('gf-bump');
          void bubble.offsetWidth;
          bubble.classList.add('gf-bump');
        }
      });
      setTimeout(function(){
        add.classList.remove('is-success');
        if (!add.classList.contains('is-maxed')) add.disabled = false;
        var num = qa2.querySelector('.gf-qa__num');
        if (num.textContent === '0') return;
      }, 1400);
    })
    .catch(function(){
      add.classList.remove('is-loading');
      setTimeout(function(){ add.disabled = false; }, 1600);
    });
  }, true);


/* --- Mobile Filter-Drawer --- */
(function () {
  var coll = document.querySelector('.gf-coll');
  var toggle = document.getElementById('gf-mobile-filter-toggle');
  var closeBtn = document.getElementById('gf-mobile-filter-close');
  var overlay = document.getElementById('gf-mobile-overlay');
  if (!coll || !toggle) return;

  function open() {
    coll.classList.add('is-filter-open');
    document.body.classList.add('gf-filter-open');
    if (closeBtn) closeBtn.focus();
  }
  function close() {
    coll.classList.remove('is-filter-open');
    document.body.classList.remove('gf-filter-open');
  }

  toggle.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && coll.classList.contains('is-filter-open')) close();
  });

  /* Bei Wechsel auf Desktop: Drawer-State aufraeumen */
  var mq = window.matchMedia('(min-width: 769px)');
  function handleMQ(e) { if (e.matches) close(); }
  if (mq.addEventListener) mq.addEventListener('change', handleMQ);
  else mq.addListener(handleMQ);
})();


/* GF 2026-09 mobil: langer Kategorietext eingeklappt, "Mehr lesen" zeigt alles */
(function () {
  var d = document.querySelector('.gf-coll__desc');
  if (!d || !window.matchMedia('(max-width: 768px)').matches) return;
  d.classList.add('is-clamped');
  if (d.scrollHeight <= d.clientHeight + 4) { d.classList.remove('is-clamped'); return; }
  var b = document.createElement('button');
  b.type = 'button'; b.className = 'gf-coll__desc-more'; b.textContent = 'Mehr lesen';
  b.setAttribute('aria-expanded', 'false');
  b.addEventListener('click', function () {
    var open = !d.classList.toggle('is-clamped');
    b.textContent = open ? 'Weniger anzeigen' : 'Mehr lesen';
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  d.parentNode.insertBefore(b, d.nextSibling);
})();
